// extracted by mini-css-extract-plugin
export default {"form":"BeCclV62","personRow":"jlJjP0Lk","personName":"sqcOaWLi","actions":"bhsjQnqv","actionButton":"NWVycV_9"};